import { render, staticRenderFns } from "./ModalAddNewFormItem.vue?vue&type=template&id=8be85fec"
import script from "./ModalAddNewFormItem.vue?vue&type=script&lang=js"
export * from "./ModalAddNewFormItem.vue?vue&type=script&lang=js"
import style0 from "./ModalAddNewFormItem.vue?vue&type=style&index=0&id=8be85fec&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8be85fec')) {
      api.createRecord('8be85fec', component.options)
    } else {
      api.reload('8be85fec', component.options)
    }
    module.hot.accept("./ModalAddNewFormItem.vue?vue&type=template&id=8be85fec", function () {
      api.rerender('8be85fec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/forms/ModalAddNewFormItem.vue"
export default component.exports